export const LINK_ACTIONS = {
  EDIT: 'edit',
  ADD_COLLECTION: 'add_collection',
  DELETE: 'delete',
  TOGGLE_FAVORITE: 'toggle_favorite',
  SHARE: 'share',
  COPY_LINK: 'copy_link',
  TAG: 'tag',
} as const;

export type LinkAction = typeof LINK_ACTIONS[keyof typeof LINK_ACTIONS];

export const COLLECTION_ACTIONS = {
  EDIT: 'edit',
  DELETE: 'delete',
  SHARE: 'share',
  SETTINGS: 'settings',
  MANAGE_MEMBERS: 'manage_members',
  FAVORITE: 'favorite',
  ARCHIVE: 'archive'
} as const;

export type CollectionAction = typeof COLLECTION_ACTIONS[keyof typeof COLLECTION_ACTIONS];

export const MAX_TAGS_PER_LINK = 10;

export const TAG_STORAGE_KEY = 'cached_tags';

export const TAG_ACTIONS = {
  ADD: 'add_tag',
  REMOVE: 'remove_tag',
  CREATE: 'create_tag',
  SEARCH: 'search_tags',
} as const;

export type TagAction = typeof TAG_ACTIONS[keyof typeof TAG_ACTIONS]; 